import React, { useEffect, useCallback, useState } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import appConfig from 'app-config';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { MLStackTraceBoxComponent } from 'ml-components-common-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import { MLReadableErrorUtil } from 'ml-portals-util-react';

import metadata from './MLContactUs.metadata.json5';
import styles from './MLContactUs.module.scss';
import messages from './MLContactUs.messages';

const ENTITY_VALIDATION_ERROR_CODE = '608';
const RATING_ERROR_CODE = '806';
const GEOSPATIAL_RATING_ERROR_CODE = '807';
const DOWN_PAYMENT_ERROR_MSG = 'Payment must be received prior to issuing policy';
const GW_ERROR_CODE = 'GW_ERROR';

function MLContactUs(props) {
    const { 
        history,
        match,
        location 
    } = props;
    const { errorCodes } = appConfig;
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { replaceUnreadableError } = MLReadableErrorUtil();
    const isGPA = appConfig.portalCode === 'GPA';
    const quoteIDFromWizard = _.get(location, 'state.gwInfo.params[0].quoteID');
    const quoteIDFromServerCall = _.get(location, 'state.error.gwInfo.params[0]');
    const quoteIDFromCustomMessage = _.get(location, 'state.customError.quoteID');
    const quoteIDFromOfferings = _.get(location, 'state.gwInfo.params[0][0].quoteID')
    const quoteID = quoteIDFromWizard || quoteIDFromServerCall || quoteIDFromCustomMessage || quoteIDFromOfferings;
    
    const modelValue = _.get(location, 'state.gwInfo.params[0]', {});
    const postalCodeFromModel = _.get(modelValue, 'baseData.policyAddress.postalCode');
    const postalCodeFromCustomError = _.get(location, 'state.customError.postalCode');
    const postalCode = postalCodeFromModel || postalCodeFromCustomError;
    
    const accountNumberfromState = _.get(location, 'state.accountNumber');
    const accountNumberFromWizard = _.get(location, 'state.gwInfo.params[0].baseData.accountNumber')
    const accountNumber = accountNumberfromState || accountNumberFromWizard;

    const [stateErrorMsgs, setStateErrorMsgs] = useState([]);
    const [stateContactUsMsg, setStateContactUsMsg] = useState(messages.mlDefaultContactUs);
    const [stateDisplayableErrorMsgs, setStateDisplayableErrorMsgs] = useState([]);
    const [stateHasValidationErrors, setStateHasValidationErrors] = useState(false);
    const [stateAreValidationErrorsFixable, setStateAreValidationErrorsFixable] = useState(false);
    const [stateErrorCode, setStateErrorCode] = useState('');
    const [appErrors, setAppErrors] = useState([]);
    const [stackTrace, setStackTrace] = useState('');
    const [currentUser, setCurrentUser] = useState({});
    const isIA = _.get(currentUser, 'isIA');
    const isPCS = _.get(currentUser, 'isPCS');
    const isMetGA = _.get(currentUser, 'isMetGA');

    const isProduction = () => {
        const hostname = window.location.hostname.split(".")[0];
        return hostname?.indexOf('fwsprod-prod') > -1;
    };

    const parseParamsFromBaseErrorString = useCallback((baseErrorString) => {
        let uwIssues = [];

        let messageString;
        let stackTraceString;
        let formattedStackTraceString;
        let displayableErrorMessages = [];

        if (!baseErrorString) {
            return {};
        }

        // Split strings into before and after stack trace
        const indexOfStackTrace = baseErrorString ? baseErrorString.indexOf('StackTrace_ML') : -1;
        const indexOfMessages = baseErrorString ? baseErrorString.indexOf('Messages_ML') : -1;
        if (indexOfStackTrace !== -1) {
            stackTraceString = baseErrorString.substring(indexOfStackTrace);
        }
        
        if (indexOfMessages !== -1) {
            messageString = baseErrorString.substring(0, indexOfMessages);
        } else if (indexOfStackTrace !== -1) {
            messageString = baseErrorString.substring(0, indexOfStackTrace);
        } else {
            messageString = baseErrorString || '';
        }

        const errorMessageStringArray = messageString.split(' ');
        const outerErrorCodeIndex = messageString.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;

        const innerErrorCodeIndex = errorMessageStringArray.lastIndexOf('ErrorCode:');
        const innerErrorCodeValue = innerErrorCodeIndex !== -1 ? errorMessageStringArray[innerErrorCodeIndex + 1] : undefined;
        const innerErrorCodeNumericValue = !_.isUndefined(innerErrorCodeValue) ? parseInt(innerErrorCodeValue, 10) : undefined


        // Get UW Issues
        if (outerErrorCodeNumericValue === errorCodes.APPLICATION_ERROR_ML && messageString.indexOf('|') !== -1) {
            const errorMsgsByNewLine = messageString.split('|');
            const uwIssuesArrayNonFormatted = errorMsgsByNewLine.splice(1);
            uwIssues = uwIssuesArrayNonFormatted.map((uwIssueStr) => {
                // UWIssues in format of code_ML:{code};LongDescription:{desc};|
                if (uwIssueStr.includes('Code_ML') && uwIssueStr.includes('LongDescription')) {
                    const uwIssuesStringArray = uwIssueStr.split(';');
                    return {
                        code_ML: uwIssuesStringArray[1],
                        longDescription: uwIssuesStringArray[3]
                    };
                }
            })
        } else if (outerErrorCodeNumericValue === errorCodes.DISPLAYABLE_ERROR_ML && baseErrorString.indexOf('|Declined:') !== -1) {
            const messagesML = baseErrorString.match(new RegExp("Messages_ML\: \\[(.*)\\]"));
            const messagesSplit = messagesML[1].split("|");
            displayableErrorMessages = messagesSplit;
        } else {
            const indexOfMessageSplit = messageString.indexOf('|');
            if (indexOfMessageSplit !== -1) {
                const fullErrorMessageString = messageString.substring(0, indexOfMessageSplit);
                const errorMessageSplit = fullErrorMessageString.split('ErrorMessage:');
                if (errorMessageSplit.length > 0) {
                    const readableErrorMessages = errorMessageSplit.map((message) => replaceUnreadableError(message));
                    displayableErrorMessages = [readableErrorMessages[1]];
                }
            } else {
                try{
                    displayableErrorMessages = messageString.split('ErrorMessage:')
                        .filter((msg) => !msg.includes("ErrorCode:"))
                        .map((msg) => {
                            const idx = msg.indexOf("ExceptionML:");
                            if(idx > -1){
                                return msg.substring(idx).replace("ExceptionML:", "").trim();
                            }
                            return msg;
                        });
                }catch(e){
                    console.error(e);
                    displayableErrorMessages = [];
                }
            }
        }

        if (stackTraceString) {
            const startIndexOfStackTrace = stackTraceString.indexOf(':');
            formattedStackTraceString = stackTraceString.substring(startIndexOfStackTrace + 1);
        }

        return {
            outerErrorCode: outerErrorCodeNumericValue,
            innerErrorCode: innerErrorCodeNumericValue,
            uwIssues,
            formattedStackTraceString,
            displayableErrorMessages
        }
    }, [errorCodes, replaceUnreadableError]);

    const isRatingError = (errorCode) => {
        return errorCode === RATING_ERROR_CODE || errorCode === GEOSPATIAL_RATING_ERROR_CODE;
    };

    const getErrorMsgsForIAPCSMetGA = useCallback((error, errorCode, hasValidationErrors, areValidationErrorsFixable, retryable) => {
        function translate(message, args = {}) {
            return (
                <span>
                    {translator(message, {...args,
                        strong: (chunks) => <strong>{chunks}</strong>
                    })}
                </span>
            );
        }

        const errorMsgs = [];
        if (hasValidationErrors && areValidationErrorsFixable) {
            errorMsgs.push(translate(messages.IAPCSFixable))
            const message1 = isPCS ? translate(messages.EAPCSFixableContactUs) : translate(messages.IAPCSFixableContactUs);
            if(quoteID && errorCode) {
                const message2 = translate(messages.IAPCSFixableContactUs2, {
                    quoteNumber: quoteID,
                    errorCode
                });
                errorMsgs.push(<>{message1} {message2}</>);
            }else{
                errorMsgs.push(message1);
            }
        } else if (hasValidationErrors && !areValidationErrorsFixable) {
            isPCS ? errorMsgs.push(translate(messages.EAPCSNonFixable)) : errorMsgs.push(translate(messages.IAPCSNonFixable));
            if (quoteID && errorCode) {
                const message1 = translate(messages.IAPCSNonFixableContactUs, {
                    quoteNumber: quoteID,
                    errorCode
                });
                errorMsgs.push(message1);
            }
        } else {
            errorMsgs.push(translate(messages.IAPCSDefault))
            if (quoteID) {
                if(isRatingError(errorCode)) {
                    const message1 = translate(messages.IAPCSDefaultQuoteContactUs);
                    if(quoteID && errorCode) {
                        const message2 = isPCS ? translate(messages.EAPCSDefaultQuoteContactUs2) : translate(messages.IAPCSDefaultQuoteContactUs2, {
                            quoteNumber: quoteID,
                            errorCode
                        });
                        errorMsgs.push(<>{message1} {message2}</>);
                    }else{
                        errorMsgs.push(message1);
                    }
                } else {
                    const message1 = isPCS ? translate(messages.EAPCSDefaultQuoteContactUsWithoutErrorCode) : translate(messages.IAPCSDefaultQuoteContactUsWithoutErrorCode);
                    if(quoteID) {
                        const message2 = translate(messages.IAPCSDefaultQuoteContactUsWithoutErrorCode2, {
                            quoteNumber: quoteID,
                            errorCode
                        });
                        errorMsgs.push(<>{message1} {message2}</>);
                    }else{
                        errorMsgs.push(message1);
                    }
                }
            }else if(isRatingError(errorCode)) {
                const message1 = isPCS ? translate(messages.EAPCSDefaultContactUs) : translate(messages.IAPCSDefaultContactUs);
                if(errorCode) {
                    const message2 = translate(messages.IAPCSDefaultContactUs2, {
                        quoteNumber: quoteID,
                        errorCode
                    });
                    errorMsgs.push(<>{message1} {message2}</>);
                }else{
                    errorMsgs.push(message1);
                }
            }else{
                const message1 = isPCS ? translate(messages.EAPCSDefaultQuoteContactUsWithoutErrorCode) : translate(messages.IAPCSDefaultQuoteContactUsWithoutErrorCode);
                if(quoteID) {
                    const message2 = translate(messages.IAPCSDefaultQuoteContactUsWithoutErrorCode2, {
                        quoteNumber: quoteID,
                        errorCode
                    });
                    errorMsgs.push(<>{message1} {message2}</>);
                }else{
                    errorMsgs.push(message1);
                }
            }
        }
        return errorMsgs;
    }, [quoteID, translator, isPCS]);
    const getErrorMsgsForGCS = useCallback((error, errorCode, hasValidationErrors, areValidationErrorsFixable, _retryable) => {
        function translate(message, args = {}){
            return (
                <span>
                    {translator(message, {...args,
                        strong: (chunks) => <strong>{chunks}</strong>
                    })}
                </span>
            );
        }

        const errorMsgs = [];
        if (hasValidationErrors && areValidationErrorsFixable) {
            errorMsgs.push(translate(messages.GCSFixable))
        } else if (hasValidationErrors && !areValidationErrorsFixable) {
            const message1 = translate(messages.GCSNonFixable);
            if(quoteID && errorCode){
                const message2 = translate(messages.GCSNonFixable2, {
                    quoteNumber: quoteID,
                    errorCode
                });
                errorMsgs.push(<>{message1} {message2}</>);
            }else{
                const message2 = translate(messages.contactSupportTeamNoData);
                errorMsgs.push(<>{message1} {message2}</>);
            }
        } else {
            errorMsgs.push(translate(messages.GCSDefault))
            if(isRatingError(errorCode)){
                if(quoteID && errorCode){
                    const message1 = translate(messages.GCSDefaultContactUs, {
                        quoteNumber: quoteID,
                        errorCode
                    });
                    errorMsgs.push(message1);
                }else{
                    errorMsgs.push(translate(messages.contactSupportTeamNoData))
                }
            }else if(quoteID){
                const message1 = translate(messages.GCSDefaultContactUsWithoutErrorCode, {
                    quoteNumber: quoteID,
                    errorCode
                });
                errorMsgs.push(message1);
            }else{
                errorMsgs.push(translate(messages.contactSupportTeamNoData))
            }
        }
        return errorMsgs;
    }, [quoteID, translator]);

    const getErrorMsgs = useCallback((error, errorCode, hasValidationErrors, areValidationErrorsFixable, retryable) => {
        let errorMessages;
        if (isPCS || isIA || isMetGA) {
            errorMessages = getErrorMsgsForIAPCSMetGA(error, errorCode, hasValidationErrors, areValidationErrorsFixable, retryable);
        } else {
            errorMessages = getErrorMsgsForGCS(error, errorCode, hasValidationErrors, areValidationErrorsFixable, retryable);
        }
        return errorMessages;
    }, [getErrorMsgsForGCS, getErrorMsgsForIAPCSMetGA, isIA, isMetGA, isPCS]);

    const getDetailedErrorMsg = useCallback((errorCode, hasValidationErrors, retryable) => {
        let detailedErrorMsg = messages.mlDefaultContactUs;
        if (errorCode && quoteID) {
            if (hasValidationErrors) {
                detailedErrorMsg = messages.mlContactUsChatOrCustomerService;
            } else if (errorCode === errorCodes.NON_OWNED_VEHICLE_ERROR) {
                detailedErrorMsg = messages.mlContactUsQuoteID;
            } else if (!retryable) {
                detailedErrorMsg = messages.mlContactUsQuoteIDAndErrorCode;
            } else {
                detailedErrorMsg = messages.mlContactUsChatQuoteIDAndErrorCode;
            }
        } else if (quoteID) {
            if (!retryable) {
                detailedErrorMsg = messages.mlContactUsQuoteID;
            } else {
                detailedErrorMsg = messages.mlContactUsChatQuoteID;
            }
        }
        return detailedErrorMsg;
    }, [errorCodes, quoteID]);


    const handleUWError = useCallback((error, errorMessages, contactUsMsg, errorCode, uwIssues) => {
        errorMessages = [translator(messages.mlUwIssueUnableToContinue)];
        setAppErrors(uwIssues);

        if (errorCode === errorCodes.BLOCK_QUOTE_UNDERWRITING_ERROR_WITH_REFERRAL) {
            contactUsMsg = messages.mlUwIssueContactUs;
        } else if (errorCode === errorCodes.BLOCK_QUOTE_UNDERWRITING_ERROR) {
            contactUsMsg = messages.mlContactUsQuoteID;
        } else {
            errorMessages = getErrorMsgs(error, errorCode);
            contactUsMsg = getDetailedErrorMsg(errorCode);
        }
        setStateErrorMsgs(errorMessages);
        setStateContactUsMsg(contactUsMsg);
    }, [errorCodes, getDetailedErrorMsg, getErrorMsgs, translator]);

    const hasFixableValidationErrorsOnly = useCallback((errorCode, errorMessages) => {
        if (errorCode === ENTITY_VALIDATION_ERROR_CODE && errorMessages.length > 0) {
            return !errorMessages.find((err) => err.indexOf(DOWN_PAYMENT_ERROR_MSG) > -1);
        }
        return false;
    }, []);


    const setDefaultErrorStateFields = useCallback(() => {
        const errorMessages = getErrorMsgs();
        const contactUsMsg = getDetailedErrorMsg();
        setStateErrorMsgs(errorMessages);
        setStateContactUsMsg(contactUsMsg);
    }, [getDetailedErrorMsg, getErrorMsgs]);

    const setJSErrorMessages = useCallback(() => {
        if(location.state?.stack){
            console.error(location.state);
            if (!isProduction()) {
                setStackTrace(location.state.stack);
            }
        }
    }, [location.state])
    
    const setErrorMessages = useCallback((state) => {
        let errorCode = null;
        let errorMessages = [];
        let contactUsMsg = '';
        sessionStorage.setItem('error', state.baseError);
        try {
            if (state?.gwInfo) {
                const error = state;
                const { outerErrorCode, innerErrorCode = '0', uwIssues, formattedStackTraceString, displayableErrorMessages = [] } = parseParamsFromBaseErrorString(error.baseError);
                errorCode = state.errorCode === GW_ERROR_CODE ? innerErrorCode : state.errorCode;
                if (!_.isEmpty(uwIssues)) {
                    handleUWError(error, errorMessages, contactUsMsg, errorCode, uwIssues);
                    setStateErrorCode(errorCode);
                } else {
                    const hasValidationErrors = errorCode === ENTITY_VALIDATION_ERROR_CODE || displayableErrorMessages.length > 0;
                    const areValidationErrorsFixable = hasFixableValidationErrorsOnly(errorCode, displayableErrorMessages);
                    errorMessages = getErrorMsgs(error, errorCode, hasValidationErrors, areValidationErrorsFixable);
                    contactUsMsg = getDetailedErrorMsg(errorCode, hasValidationErrors);
                    setStateErrorMsgs(errorMessages);
                    setStateContactUsMsg(contactUsMsg);
                    setStateDisplayableErrorMsgs(displayableErrorMessages);
                    setStateHasValidationErrors(hasValidationErrors);
                    setStateAreValidationErrorsFixable(areValidationErrorsFixable);
                    setStateErrorCode(errorCode);
                }

                if (formattedStackTraceString) {
                    setStackTrace(formattedStackTraceString);
                }
            } else if (state?.customError) {
                const error = state.customError;
                const appErrorMessages = error.appErrorMessages;
                const displayableMsgs = error.displayableErrorMsgs;
                if (!_.isEmpty(appErrorMessages)) {
                    setStateErrorMsgs(appErrorMessages);
                } else {
                    setStateErrorMsgs(getErrorMsgs(null, null, true, true));
                }
                if (!_.isEmpty(displayableMsgs)) {
                    setStateDisplayableErrorMsgs(displayableMsgs)
                }
                if (error.fixable) {
                    setStateAreValidationErrorsFixable(true);
                }

                setStateContactUsMsg(error.contactUsMessage);
                setStateErrorCode(error.errorCode);
            } else {
                setDefaultErrorStateFields();
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            setDefaultErrorStateFields();
        }
    }, [getDetailedErrorMsg, getErrorMsgs, handleUWError, hasFixableValidationErrorsOnly, parseParamsFromBaseErrorString, setDefaultErrorStateFields]);

    // Truncate a string to a maximum length for segment props
    const truncateString = (text) => {
        const MAX_LENGTH = 1000;
        if (typeof text !== 'string') {
            return text;
        }
        if (text.length > MAX_LENGTH) {
            return text.slice(0, MAX_LENGTH) + '...[truncated]';
        }
        return text;
    };

    useEffect(() => {
        if (!isGPA) 
            return;
        setTimeout(() => {
            const properties = JSON.parse(sessionStorage.getItem('segmentProps'));
            const errorType = sessionStorage.getItem('error');
            const step = sessionStorage.getItem('lastStep');
            const action = sessionStorage.getItem('lastAction');
            const isCompRater = sessionStorage.getItem('isCompRater');
            const compRaterVendorName = sessionStorage.getItem('compRaterVendorName');
            const isBundle = sessionStorage.getItem('isBundle');
            const error_stack_trace = document.getElementById('stackTraceBoxContainer')?.innerText;
            const error_message  = document.getElementById('displayableErrorMessage')?.innerText;
            const { uwIssues,displayableErrorMessages, formattedStackTraceString = []} = parseParamsFromBaseErrorString(errorType);
            
            window.analytics.track('Quote Failed', {
                last_step: step, 
                quote_number: quoteID,
                last_action: action,
                quote_type: properties?.quote_type,
                pol_state: properties?.pol_state,
                user_type: properties?.user_type,
                agent_id: properties?.agent_id,
                isPFMReturned: properties?.isPFMReturned,
                app_name: properties?.app_name,
                app_parent: properties?.app_parent,
                lob: properties?.lob,
                error_description: truncateString(displayableErrorMessages),
                error_type: truncateString(errorType),
                uwIssues: uwIssues,
                stackTrace: truncateString(formattedStackTraceString),
                isCompRater: isCompRater,
                compRaterVendorName: compRaterVendorName,
                isBundle: isBundle,
                error_message: truncateString(error_message),
                error_stack_trace: truncateString(error_stack_trace)
            });
        }, 100);
    }, []);

    useEffect(() => {
        UserService.getCurrentUser(authHeader).then((user) => {
            setCurrentUser(user);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        MLTagManagerService.sendEvent('quoteError', {form: 'Quote Generation Failure'});
        if(currentUser){
            if(!location.state?.baseError && location.state?.stack){
                // JS Error
                setJSErrorMessages(location.state);
                setDefaultErrorStateFields()
            }else{
                setErrorMessages(location.state);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser])
    

    const onReturnToAccountDetailsClick = () =>{
        history.push(`/accounts/${accountNumber}/summary`);

    };

    const onReturnToQuoteClick = () =>{
        history.push('/quoteentry', {quoteID: quoteID, postalCode: postalCode});
    };

    const overrideProps = {
        unableToCompleteQuoteTitle: {
            visible: stateHasValidationErrors && stateAreValidationErrorsFixable
        },
        unableToCompleteQuoteOnlineTitle: {
            visible: !(stateHasValidationErrors && stateAreValidationErrorsFixable)
        },
        errorMessagesSection: {
            visible: stateErrorMsgs.length > 0
        },
        errorMessage: {
            data: stateErrorMsgs && stateErrorMsgs.map((val) => {return {message: val}})
        },
        displayableErrorMessagesSection: {
            visible: stateDisplayableErrorMsgs.length > 0
        },
        reasonsDiv: {
            visible: stateErrorMsgs.length > 0
        },
        displayableErrorMessage: {
            data: stateDisplayableErrorMsgs.map((val) => {return {message: val}})
        },
        returnToQuoteLink: {
            visible: !!quoteID && !!postalCode && stateAreValidationErrorsFixable
        },
        returnToAccountLink: {
            visible: !!accountNumber && !(!!quoteID && !!postalCode && stateAreValidationErrorsFixable)
        },
        mlstacktracebox: {
            visible: !_.isEmpty(stackTrace),
            stackTrace
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onReturnToAccountDetailsClick,
            onReturnToQuoteClick
        },
        resolveComponentMap: {
            mlstacktraceboxcomponent: MLStackTraceBoxComponent
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

export default withRouter(MLContactUs);